import { useNavigate } from 'react-router';
import { useContext, useEffect } from 'react';

import UserContext, { hasPermissions } from '../common/user';

export default function Home() {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  const canSeeDashboard = hasPermissions(user, ['orders.get']);

  useEffect(() => {
    if (!user) {
      navigate('/login');
    } else if (canSeeDashboard) {
      navigate('/dashboard');
    } else {
      navigate('/report');
    }
  }, [user]);

  return null;
}
